
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Merchant } from "@/types";
import { MapPin } from "lucide-react";

interface MerchantCardProps {
  merchant: Merchant;
}

const MerchantCard: React.FC<MerchantCardProps> = ({ merchant }) => {
  return (
    <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow duration-200">
      <CardContent className="p-0">
        <div className="p-5">
          <div className="flex items-center mb-4">
            {merchant.logo_path ? (
              <div className="w-16 h-16 mr-4">
                <img
                  src={merchant.logo_path}
                  alt={`${merchant.business_name} logo`}
                  className="w-full h-full object-contain rounded-md"
                />
              </div>
            ) : (
              <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center mr-4">
                <span className="text-gray-400 text-xs">No Logo</span>
              </div>
            )}
            <h3 className="text-xl font-bold truncate">{merchant.business_name}</h3>
          </div>
          
          {merchant.description && (
            <p className="text-gray-600 text-sm line-clamp-2 mb-4">{merchant.description}</p>
          )}

          {merchant.address && (
            <div className="flex items-center text-sm text-gray-500">
              <MapPin className="h-4 w-4 mr-1" />
              <span className="truncate">{merchant.address}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default MerchantCard;
